/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * React 19 compatible copy to clipboard hook
 */

import { useState } from 'react';

const useCopyToClipboard = () => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            // Reset copied state after 2 seconds
            setTimeout(() => setCopied(false), 2000);
            return true;
        } catch (err) {
            console.error('Failed to copy text: ', err);
            return false;
        }
    };

    return { copied, copyToClipboard };
};

export default useCopyToClipboard;
